import { config } from "@financial-advisory/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "../baseQuery";

export const productRecommendationApi = createApi({
  reducerPath: "productRecommendationApi",
  baseQuery: createBaseQuery(config.PRODUCT_RECOMMENDATION_API_BASE_URL),
  endpoints: () => ({}),
  tagTypes: [""],
});
